import React from 'react';
import { useState } from 'react';
import { useAuth } from '../../hooks/useAuth.js';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../../lib/firebase.js';

export default function UserProfile() {
  const { user, isAdmin, isPizzeria } = useAuth();
  const [formData, setFormData] = useState({
    name: user?.name || user?.displayName || '',
    phone: user?.phone || '',
    email: user?.email || ''
  });
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!user) return;

    setLoading(true);
    setMessage('');
    setError('');

    try {
      await updateDoc(doc(db, 'users', user.uid), {
        name: formData.name,
        phone: formData.phone,
        updatedAt: new Date().toISOString()
      });
      setMessage('Profilo aggiornato con successo');
    } catch (err) {
      setError('Errore durante l\'aggiornamento del profilo');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-2xl mx-auto">
      <h2 className="text-2xl font-bold mb-6">Il tuo profilo</h2>
      
      <form onSubmit={handleSubmit} className="space-y-6">
        <div>
          <label htmlFor="email" className="block text-sm font-medium text-gray-700">
            Email
          </label>
          <input
            type="email"
            id="email"
            value={user?.email || ''}
            disabled
            className="mt-1 block w-full rounded-md border-gray-300 bg-gray-50 shadow-sm"
          />
        </div>

        <div>
          <label htmlFor="name" className="block text-sm font-medium text-gray-700">
            Nome
          </label>
          <input
            type="text"
            id="name"
            value={formData.name}
            onChange={(e) => setFormData(prev => ({ ...prev, name: e.target.value }))}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-pizzaveg focus:ring-pizzaveg"
          />
        </div>

        <div>
          <label htmlFor="phone" className="block text-sm font-medium text-gray-700">
            Telefono
          </label>
          <input
            type="tel"
            id="phone"
            value={formData.phone}
            onChange={(e) => setFormData(prev => ({ ...prev, phone: e.target.value }))}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-pizzaveg focus:ring-pizzaveg"
          />
        </div>

        {message && (
          <div className="text-green-600">
            {message}
          </div>
        )}

        {error && (
          <div className="text-red-600">
            {error}
          </div>
        )}

        <div>
          <button
            type="submit"
            disabled={loading}
            className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-pizzaveg hover:bg-pizzaveg-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-pizzaveg disabled:opacity-50"
          >
            {loading ? 'Aggiornamento...' : 'Aggiorna profilo'}
          </button>
        </div>
      </form>
    </div>
  );
}